import { createContext, useContext } from 'react';

/**
 * Context to share the currently selected tab index with child components
 */
export const TabIndexContext = createContext<number | undefined>(undefined);

/**
 * Hook to get the current tab index
 * @returns The current tab index, or undefined if not in a tabs screen
 */
export function useTabIndex(): number | undefined {
  return useContext(TabIndexContext);
}
